import { X } from "lucide-react";

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      data-testid="terms-modal-overlay"
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-slate-950/90 backdrop-blur-sm"></div>
      <div 
        data-testid="terms-modal"
        className="relative z-10 bg-slate-900 rounded-2xl border border-slate-800 w-full max-w-4xl max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-800">
          <h2 
            className="text-2xl font-semibold text-white"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Terminos y Condiciones
          </h2>
          <button
            data-testid="terms-close-btn"
            onClick={onClose}
            className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 md:p-8 text-slate-300 space-y-6">
          <div className="text-sm text-slate-500 mb-4">
            <p><strong>Version:</strong> 1.0</p>
            <p><strong>Fecha de entrada en vigencia:</strong> 01/05/2026</p>
          </div>

          <h3 className="text-xl font-semibold text-cyan-400 mt-6">TERMINOS Y CONDICIONES GENERALES DE USO DE MORPHYNG</h3>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">1. OBJETO</h4>
            <p className="text-sm leading-relaxed mb-3">
              Los presentes Terminos y Condiciones Generales regulan el acceso, registro, utilizacion y funcionamiento 
              de la aplicacion movil, plataforma digital, sitio web, portal web, servicios de pago, cuenta de pago, 
              funcionalidades, herramientas tecnologicas, modulos, productos y demas servicios ofrecidos por MORPHYNG S.A., 
              en adelante "MORPHYNG", a sus usuarios.
            </p>
            <p className="text-sm leading-relaxed mb-3">
              La utilizacion de la Plataforma, la apertura o mantenimiento de una cuenta, el acceso a cualquiera de los servicios, 
              la ejecucion de operaciones, la aceptacion digital de funcionalidades o el uso continuado de MORPHYNG importan la 
              aceptacion plena y sin reservas de los presentes Terminos y Condiciones Generales, de la Politica de Privacidad, 
              de las condiciones particulares de cada producto o modulo y de toda otra documentacion complementaria que resulte aplicable.
            </p>
            <p className="text-sm leading-relaxed">
              Cualquier persona que no acepte estos Terminos y Condiciones debera abstenerse de registrarse, acceder, 
              operar o utilizar los servicios ofrecidos por MORPHYNG.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">2. DEFINICIONES</h4>
            <ul className="text-sm space-y-2 leading-relaxed">
              <li><strong className="text-cyan-400">MORPHYNG:</strong> MORPHYNG S.A., sociedad que presta servicios tecnologicos y de pago en el marco de la normativa aplicable.</li>
              <li><strong className="text-cyan-400">Plataforma:</strong> la aplicacion movil, sitio web, portal web, panel de usuario, backoffice, APIs, canales digitales, interfaces, modulos, servicios y herramientas tecnologicas ofrecidas por MORPHYNG.</li>
              <li><strong className="text-cyan-400">Usuario:</strong> toda persona humana o juridica que acceda, se registre, utilice o solicite el uso de los servicios de MORPHYNG.</li>
              <li><strong className="text-cyan-400">Cuenta MORPHYNG:</strong> cuenta de pago, cuenta digital o perfil operativo asignado al usuario dentro de la Plataforma.</li>
              <li><strong className="text-cyan-400">Servicios:</strong> todos los productos, funcionalidades, herramientas y prestaciones ofrecidos por MORPHYNG, incluyendo apertura y administracion de cuenta de pago, generacion de CVU, recepcion y envio de fondos, pagos, transferencias, recaudacion, cobros y demas servicios actuales o futuros.</li>
              <li><strong className="text-cyan-400">Fondos:</strong> sumas de dinero en moneda de curso legal disponibles o pendientes de acreditacion en la Cuenta MORPHYNG del usuario.</li>
              <li><strong className="text-cyan-400">CVU:</strong> Clave Virtual Uniforme asignada a una cuenta de pago para permitir su interoperabilidad dentro del sistema de pagos.</li>
              <li><strong className="text-cyan-400">Credenciales:</strong> nombre de usuario, contrasena, PIN, biometria, token, codigo OTP, dispositivo asociado, clave de acceso o cualquier otro factor de autenticacion.</li>
            </ul>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">3. NATURALEZA DE MORPHYNG COMO PROVEEDOR DE SERVICIOS DE PAGO</h4>
            <p className="text-sm leading-relaxed mb-3">
              MORPHYNG ofrece servicios de pago y tecnologia financiera. MORPHYNG no es una entidad financiera, no es un banco, 
              no presta servicios bancarios, no capta depositos del publico ni se encuentra autorizada a operar como entidad financiera 
              por el Banco Central de la Republica Argentina.
            </p>
            <p className="text-sm leading-relaxed">
              Los fondos disponibles en las cuentas de pago no constituyen depositos bancarios, no se encuentran alcanzados por 
              el regimen de garantia de los depositos bancarios ni generan los derechos propios de los depositos en entidades financieras.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">4. CAPACIDAD Y CONDICIONES DE ACCESO</h4>
            <p className="text-sm leading-relaxed mb-3">
              Solo podran registrarse y utilizar los servicios aquellas personas humanas mayores de dieciocho (18) anos, 
              con capacidad legal suficiente para contratar conforme la legislacion argentina, y aquellas personas juridicas 
              validamente constituidas y representadas.
            </p>
            <p className="text-sm leading-relaxed">
              MORPHYNG podra rechazar una solicitud de registracion, impedir el acceso, limitar funcionalidades, suspender 
              temporalmente o cancelar definitivamente una cuenta cuando existan inconsistencias, datos insuficientes, 
              incumplimientos normativos, riesgos operativos o sospechas de fraude.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">5. REGISTRO, IDENTIDAD Y DATOS DEL USUARIO</h4>
            <p className="text-sm leading-relaxed mb-3">
              Para utilizar los servicios, el usuario debera completar el proceso de registro y proporcionar la informacion 
              que MORPHYNG solicite, incluyendo datos identificatorios, fiscales, registrales, de contacto, actividad economica, 
              origen de fondos, perfil transaccional y documentacion respaldatoria.
            </p>
            <p className="text-sm leading-relaxed">
              Toda informacion suministrada por el usuario tendra caracter de declaracion jurada. El usuario garantiza y responde 
              por la veracidad, exactitud, integridad, vigencia, licitud y autenticidad de los datos.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">6. CUENTA MORPHYNG</h4>
            <p className="text-sm leading-relaxed mb-3">
              La Cuenta MORPHYNG es personal, unica, nominativa e intransferible. El usuario no podra venderla, cederla, 
              prestarla, alquilarla, compartirla, transferirla, explotarla por cuenta de terceros ni permitir su uso por terceros.
            </p>
            <p className="text-sm leading-relaxed">
              MORPHYNG podra generar o solicitar la generacion de una CVU asociada a la Cuenta MORPHYNG, cuando ello corresponda 
              segun el tipo de servicio, las condiciones de elegibilidad y la normativa aplicable.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">7. SERVICIOS Y FUNCIONALIDADES</h4>
            <p className="text-sm leading-relaxed mb-3">
              MORPHYNG podra permitir al usuario realizar transferencias a cuentas CBU o CVU, recibir fondos, realizar pagos, 
              efectuar cobros, cargar o retirar fondos, pagar servicios, utilizar modulos tecnologicos, acceder a beneficios 
              y utilizar cualquier otra funcionalidad habilitada.
            </p>
            <p className="text-sm leading-relaxed">
              MORPHYNG podra incorporar, modificar, limitar, suspender o discontinuar funcionalidades, productos o modulos, 
              total o parcialmente, cuando resulte necesario por razones tecnicas, operativas, regulatorias, comerciales o de seguridad.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">8. INSTRUCCIONES DE PAGO Y RESPONSABILIDAD DEL USUARIO</h4>
            <p className="text-sm leading-relaxed mb-3">
              El usuario es el unico responsable por las instrucciones que imparta a traves de la Plataforma, incluyendo 
              destinatarios, importes, conceptos, datos de cuentas, medios de pago, confirmaciones, autorizaciones y solicitudes.
            </p>
            <p className="text-sm leading-relaxed">
              Toda instruccion confirmada mediante las credenciales, dispositivos, factores de autenticacion, Token de Seguridad, 
              firma electronica, confirmacion digital, biometria, PIN o contrasena sera considerada valida, autentica, instruida 
              y aceptada por el usuario titular de la cuenta.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">9. ACREDITACION, DISPONIBILIDAD Y LIQUIDACION DE FONDOS</h4>
            <p className="text-sm leading-relaxed">
              Los fondos ingresados a la Cuenta MORPHYNG se acreditaran y estaran disponibles conforme los plazos, reglas, 
              validaciones, limites, procesos de liquidacion, controles internos, sistemas intervinientes y condiciones aplicables 
              a cada operatoria. MORPHYNG podra demorar, retener, bloquear o limitar la disponibilidad o retiro de fondos cuando 
              existan alertas de seguridad, controles pendientes o cualquier motivo legitimo.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">10. LIMITES OPERATIVOS</h4>
            <p className="text-sm leading-relaxed">
              MORPHYNG podra establecer limites minimos y maximos para operaciones, saldos, transferencias, pagos, ingresos, 
              retiros, cantidad de operaciones, frecuencia, destinatarios, funcionalidades, productos o cualquier otro parametro operativo.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">11. COMISIONES Y CARGOS</h4>
            <p className="text-sm leading-relaxed mb-3">
              MORPHYNG podra cobrar comisiones, cargos, tarifas, porcentajes, costos operativos, costos de procesamiento, 
              costos de servicio y cualquier otra retribucion aplicable a los servicios.
            </p>
            <p className="text-sm leading-relaxed">
              El usuario autoriza expresamente a MORPHYNG a debitar, descontar, retener o compensar de su Cuenta MORPHYNG 
              cualquier comision, cargo, deuda o saldo negativo que corresponda.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">12. SEGURIDAD DE LA CUENTA Y CREDENCIALES</h4>
            <p className="text-sm leading-relaxed mb-3">
              El usuario sera el unico responsable por la custodia, confidencialidad, resguardo y utilizacion de sus credenciales, 
              claves, contrasenas, PIN, Token de Seguridad, codigos OTP, biometria y dispositivos asociados.
            </p>
            <p className="text-sm leading-relaxed">
              MORPHYNG nunca solicitara al usuario sus claves completas, Token de Seguridad, codigos OTP o credenciales mediante 
              llamadas telefonicas, redes sociales, mensajeria informal, formularios externos o canales no habilitados.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">13. PREVENCION DE FRAUDE Y CUMPLIMIENTO NORMATIVO</h4>
            <p className="text-sm leading-relaxed">
              MORPHYNG podra monitorear operaciones, analizar patrones transaccionales, utilizar herramientas manuales o 
              automatizadas de deteccion de fraude, aplicar matrices de riesgo, verificar informacion y adoptar medidas 
              preventivas conforme sus politicas internas y la normativa aplicable.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">14. DESCONOCIMIENTO DE OPERACIONES</h4>
            <p className="text-sm leading-relaxed">
              El usuario debera comunicar inmediatamente a MORPHYNG cualquier operacion desconocida, acceso no autorizado, 
              perdida, robo o extravio del dispositivo, compromiso de credenciales, uso indebido de la cuenta, phishing, 
              fraude o incidente de seguridad.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">15. USOS PROHIBIDOS</h4>
            <p className="text-sm leading-relaxed mb-3">
              Queda expresamente prohibido utilizar MORPHYNG para realizar, facilitar o encubrir cualquier actividad ilicita, 
              incluyendo lavado de activos, financiamiento del terrorismo, fraude, estafa, evasion fiscal, contrabando, 
              corrupcion o delitos informaticos.
            </p>
            <p className="text-sm leading-relaxed">
              Tambien esta prohibido operar con datos de terceros sin autorizacion, crear cuentas falsas, simular operaciones 
              inexistentes, utilizar bots o herramientas automatizadas no autorizadas, o cualquier actividad contraria a 
              la finalidad normal de los servicios.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">16. PROPIEDAD INTELECTUAL</h4>
            <p className="text-sm leading-relaxed">
              Todos los derechos de propiedad intelectual, industrial, marcaria, autoral y tecnologica vinculados con la Plataforma, 
              aplicacion, sitio web, interfaces, disenos, software, codigo fuente, APIs, bases de datos, marcas, logotipos, 
              contenidos y demas elementos son de titularidad exclusiva de MORPHYNG o de terceros licenciantes.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">17. DATOS PERSONALES Y PRIVACIDAD</h4>
            <p className="text-sm leading-relaxed">
              El tratamiento de los datos personales del usuario se regira por la Politica de Privacidad de MORPHYNG y por la 
              normativa aplicable en materia de proteccion de datos personales. MORPHYNG adoptara medidas tecnicas, organizativas 
              y de seguridad razonables para proteger la confidencialidad e integridad de la informacion tratada.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">18. LIMITACION DE RESPONSABILIDAD</h4>
            <p className="text-sm leading-relaxed">
              MORPHYNG prestara sus servicios conforme estandares razonables de diligencia, seguridad, disponibilidad y 
              cumplimiento normativo. MORPHYNG no sera responsable por danos derivados de errores del usuario, phishing, 
              suplantacion de identidad, indisponibilidad de terceros, caso fortuito o fuerza mayor.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">19. MODIFICACIONES DE LOS TERMINOS</h4>
            <p className="text-sm leading-relaxed">
              MORPHYNG podra modificar, actualizar, complementar o reemplazar estos Terminos cuando resulte necesario. 
              Las modificaciones seran informadas por medios razonables. El uso continuado de la Plataforma con posterioridad 
              a la entrada en vigencia importara aceptacion de los nuevos terminos.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">20. LEY APLICABLE Y JURISDICCION</h4>
            <p className="text-sm leading-relaxed">
              Los presentes Terminos y Condiciones se regiran por las leyes de la Republica Argentina. Toda controversia sera 
              sometida a la jurisdiccion de los tribunales ordinarios con asiento en la Ciudad Autonoma de Buenos Aires, sin 
              perjuicio de la competencia de los fueros de orden publico que resulten irrenunciables conforme la normativa 
              aplicable en materia de defensa del consumidor y usuarios de servicios financieros.
            </p>
          </section>

          <section>
            <h4 className="text-lg font-semibold text-white mb-3">21. ACEPTACION</h4>
            <p className="text-sm leading-relaxed">
              La registracion, acceso, uso de la Plataforma, apertura o mantenimiento de una Cuenta MORPHYNG, ejecucion de 
              operaciones, utilizacion de modulos, aceptacion digital o cualquier otra manifestacion digital equivalente 
              importara la aceptacion expresa, plena y sin reservas de los presentes Terminos y Condiciones.
            </p>
          </section>

          <div className="text-xs text-slate-500 pt-6 border-t border-slate-800 mt-8">
            <p>Version resumida de los Terminos y Condiciones. Para consultar la version completa, contactenos por los canales oficiales.</p>
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-slate-800 flex justify-end">
          <button
            data-testid="terms-accept-btn"
            onClick={onClose}
            className="btn-primary px-8"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
